export default {
  "redPacketRain.redPacketRainConf": "红包雨配置",
  "redPacketRain.thead.index": "#序号",
  "redPacketRain.thead.id": "Id",
  "redPacketRain.thead.title": "红包雨名称",
  "redPacketRain.thead.type": "红包雨类型",
  "redPacketRain.thead.scopeType": "推送类型",
  "redPacketRain.thead.depositNearDays": "近几天充值",
  "redPacketRain.thead.userno": "用户编号",
  "redPacketRain.thead.probabilityList": "现金及概率配置",
  "redPacketRain.thead.amount": "金额",
  "redPacketRain.thead.probability": "概率",
  "redPacketRain.thead.pushTime": "推送时间",
  "redPacketRain.thead.pushTime.start": "开始时间",
  "redPacketRain.thead.pushTime.end": "结束时间",
  "redPacketRain.thead.action": "操作",
  "redPacketRain.tooltip.copyUserNo": "复制用户ID",
  "redPacketRain.tooltip.userDetails": "用户详细信息",
};
